import React from "react";
import Apikey from "../../../Component/ApiUser/apikey";
import { Grid, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Apiconsole from "../apiconsole/apiconsole";
import Servicesetting from "../../../Component/ApiUser/admin/servicesetting";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    height: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
  },
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
}));

const Limitsetting = () => {
  const classes = useStyle();

  return (
    <Apiconsole>
      <Apikey role="Administrator" choice={2}>
        <div className={classes.root}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <Card className={classes.cardstyle}>
                <Servicesetting />
              </Card>
            </Grid>
          </Grid>
        </div>
      </Apikey>
    </Apiconsole>
  );
};

export default Limitsetting;
